<template>
  <password-field :label="label" :placeholder="placeholder" :name="name" v-model="password" :email="email"/>
</template>

<script>
import PasswordField from "./PasswordField.vue";

export default {
  components: {
    PasswordField
  },
  props: ['label', 'name', 'placeholder', 'email_field_id', 'email_value'],
  data() {
    return {
      password: null,
      email: this.email_value
    }
  },
  mounted() {
    if (this.email_field_id) {
      const field = this.emailField();
      field.on('input', () => {
        this.email = field.val()
        console.log("email changed", this.email);
      })
    }
  },

  methods: {
    emailField() {
      if (this.email_field_id) {
        return $(`#${this.email_field_id}`)
      }
    },
  },

  beforeDestroy() {
    this.emailField()?.off('change')
  },

}
</script>